import React from 'react'

import { AnimatePresence } from 'motion/react'

import {
  CardPending,
  type CardPendingData,
  type CardPendingLabels,
  type CardPendingState,
  type CardPendingTimeFormat,
} from '@/components/molecules/CardPending/CardPending.tsx'
import { type CardListState, cardStateInList } from '@/components/organisms/CardList/CardListState.ts'
import { cn } from '@/lib/utils.ts'

export type CardListPendingTimeFormat = CardPendingTimeFormat

export interface CardListPendingLabels extends CardPendingLabels {}

export type CardListPendingData = Array<CardPendingData & { id: string }>

export interface CardListPendingActions {
  onActivate: (requestId: string) => void
  onCancelRequest: (requestId: string) => void
  onAssignManually: (requestId: string) => void
  onAssignTeam: (requestId: string, teamId: string) => void
  onClose: () => void
}

export interface CardListPendingProps
  extends
    React.HtmlHTMLAttributes<HTMLDivElement>,
    CardListPendingTimeFormat,
    CardListPendingActions,
    Pick<CardPendingState, 'size' | 'selectedTeam'> {
  labels: CardListPendingLabels
  data?: CardListPendingData
  state?: CardListState
}

export const CardListPending = React.forwardRef<HTMLDivElement, CardListPendingProps>(
  (
    {
      className,
      labels,
      data = [],
      state,
      size,
      selectedTeam,
      timeAgoFormatter,
      willExecuteInTimeAgoFormatter,
      onActivate,
      onCancelRequest,
      onAssignManually,
      onAssignTeam,
      onClose,
      ...props
    },
    ref
  ) => (
    <div className={cn('flex flex-col', className)} ref={ref} {...props}>
      <AnimatePresence initial={false}>
        {data.map((card) => (
          <CardPending
            {...card}
            key={card.id}
            labels={labels}
            size={size}
            state={cardStateInList(card.id, state)}
            highlighted={state?.highlighted === card.id}
            selectedTeam={cardStateInList(card.id, state) === 'selected' ? selectedTeam : undefined}
            timeAgoFormatter={timeAgoFormatter}
            willExecuteInTimeAgoFormatter={willExecuteInTimeAgoFormatter}
            onClick={() => {
              if (!['selected', 'disabled'].includes(cardStateInList(card.id, state))) {
                onActivate(card.id)
              }
            }}
            onCancelRequest={() => {
              onCancelRequest(card.id)
            }}
            onAssignManually={() => {
              onAssignManually(card.id)
            }}
            onAssignTeam={(teamId) => {
              onAssignTeam(card.id, teamId)
              onActivate(card.id)
            }}
            onClose={onClose}
          />
        ))}
      </AnimatePresence>
    </div>
  )
)
